var map = {
	"./big_sale.svg": 9082,
	"./birthday_special.svg": 7977,
	"./bulk_order_discount.svg": 5079,
	"./diwali_offer.svg": 9365,
	"./family_discount.svg": 8160,
	"./festival_season.svg": 6646,
	"./flat_1000_off.svg": 5483,
	"./loyalty_bonus.svg": 6496,
	"./new_customer.svg": 6299,
	"./preferred_partner.svg": 4854,
	"./sale_season.svg": 2953,
	"./seasonal_discount.svg": 2196,
	"./student_discount.svg": 3499,
	"./summer_sale.svg": 2789,
	"./vip_customer_discount.svg": 1496,
	"./welcome_bonus.svg": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1562;